import { render, staticRenderFns } from "./custom-chrome-picker.vue?vue&type=template&id=35b4218e&scoped=true&"
import script from "./custom-chrome-picker.vue?vue&type=script&lang=js&"
export * from "./custom-chrome-picker.vue?vue&type=script&lang=js&"
import style0 from "./custom-chrome-picker.vue?vue&type=style&index=0&id=35b4218e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b4218e",
  null
  
)

export default component.exports